module.exports = __webpack_public_path__ + "img/pluto24.93bfc958.jpg";